import { render, staticRenderFns } from "./TabelaCoparticipacao.vue?vue&type=template&id=1cb4a469&scoped=true&"
import script from "./TabelaCoparticipacao.vue?vue&type=script&lang=js&"
export * from "./TabelaCoparticipacao.vue?vue&type=script&lang=js&"
import style0 from "./TabelaCoparticipacao.vue?vue&type=style&index=0&id=1cb4a469&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb4a469",
  null
  
)

export default component.exports